import React, { Component } from 'react';
import Contentful from '../../components/contentful';
import SeoTags from '../../components/seo/seo';
import SectionsRenderer from '../../components/sections/renderer';
import NotFound from '../../components/layout/notFound/notFound';
import styles from './page.scss';

class Page extends Component {
  render() {
    const slug = this.props.match.params.slug;

    const query = slug === undefined ? { content_type: 'page', limit: 1, 'fields.slug': '/', include: 5 } : { content_type: 'page', limit: 1, 'fields.slug': slug, include: 5 };

    return (
      <Contentful key={slug} loadingIndicator={true} query={query}>
        {({ items, total }) => {

          if (items.length === 0 && total === 0) { return <NotFound/>; }
          if (items.length === 0) { return null; }

          const page = items[0];
          const pageClass = page.fields.title !== 'Startseite' ? styles[page.fields.title.toLowerCase()] : styles.home;

          // seo / social
          const title = page.fields.title;
          const sharingImage = page.fields.sharingImage ? page.fields.sharingImage.fields.file.url : null;
          const description = page.fields.sharingDescription;
          const currentUrl = window.location.href;

          return (
            <div className={[styles.container, pageClass].join(' ')}>
              <SeoTags title={title} sharingImage={sharingImage} description={description} currentUrl={currentUrl}/>
              {( slug !== undefined &&
                <h1 className={styles.title}>{page.fields.title}</h1>
              )}
              {( page.fields.sections &&
                <SectionsRenderer sections={page.fields.sections}/>
              )}
            </div>
          )
        }}
      </Contentful>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/containers/page/page.jsx